import React from 'react'

import { Table } from '_zari/core'

import * as Rows from './rows'

const tableHeaderRows = [
  {
    label: 'COD PROD ORIGEN',
    filter: {
      type: 'text',
      name: 'codigoProductoOrigen'
    }
  },
  {
    label: 'NOM PROD ORIGEN',
    filter: {
      type: 'text',
      name: 'nombreProductoOrigen'
    }
  },
  {
    label: 'COD PROD PROMOC',
    filter: {
      type: 'text',
      name: 'codigoProductoPromocion'
    }
  },
  {
    label: 'NOM PROD PROMOC',
    filter: {
      type: 'text',
      name: 'nombreProductoPromocion'
    }
  },
  { label: 'FECHA INICIO' },
  { label: 'FECHA FIN' },
  { label: 'CANT ACTIVACION' },
  { label: 'FACTOR' },
  { label: '', width: 60 }
]

const MainTable = () => {
  const tablaRef = React.useRef()

  const reloadTable = React.useCallback(() => {
    tablaRef.current.reload()
  }, [])

  return (
    <Table.ServerSide
      ref={tablaRef}
      useFilters={true}
      useNest={true}
      url='/promociones'
      headRows={tableHeaderRows}
      rowTemplate={row => <Rows.MainRow key={row._id} row={row} reloadTable={reloadTable} />}
    />
  )
}

export default React.memo(MainTable)
